import AddActionIcon from 'icons/AddActionIcon'
import CategoriesIcon from 'icons/iam/CategoriesIcon'
import { statusOptions } from '../helpers'
import { Autocomplete } from '@fullscreendigital/carrefour-dex-fe'
import { AddShoppingCart, Assignment, BusinessOutlined } from '@mui/icons-material'
import { URLS } from 'components/iam/constants'

export const toolbarActions = ({ canCreate, navigate, openModal }) => {
  const toolbar = [
    {
      label: 'Partners',
      icon: <CategoriesIcon width={18} strokeColor={'#0970E6'} />,
      onClick: () => navigate('/iam/externalPartners')
    },
    {
      label: 'Managers',
      icon: <CategoriesIcon width={18} strokeColor={'#0970E6'} />,
      onClick: () => navigate('/iam/externalPartners/managers')
    },
    {
      label: 'Assignments',
      icon: <Assignment width={18} style={{ color: '#0970E6' }} />,
      onClick: () => navigate(URLS.IAM_ASSIGNMENTS)
    },
    {
      label: 'Legal entities',
      icon: <BusinessOutlined width={18} style={{ color: '#0970E6' }} />,
      onClick: () => navigate(URLS.IAM_LEGAL_ENTITIES)
    },
    {
      label: 'Stores',
      icon: <AddShoppingCart width={18} style={{ color: '#0970E6' }} />,
      onClick: () => navigate(URLS.IAM_STORES)
    }
  ]
  const createButton = {
    label: 'Add delegate',
    icon: <AddActionIcon />,
    onClick: () => openModal()
  }
  if (canCreate) {
    toolbar.push(createButton)
  }
  return toolbar
}

export const columns = [
  {
    field: 'firstName',
    title: 'Name',
    align: 'left',
    disableSorting: true,
    render: rowData => `${rowData.firstName} ${rowData.lastName}`
  },
  { field: 'email', title: 'Email', align: 'left' },
  { field: 'phone', title: 'Phone', align: 'left', collapsible: true },
  {
    field: 'activeAssignmentsCount',
    title: 'Assignments',
    align: 'left',
    collapsible: true,
    width: '180px',
    render: row => row.activeAssignmentsCount || 'No active assignments'
  },
  {
    field: 'isEnabled',
    title: 'Status',
    align: 'left',
    collapsible: true,
    width: '100px',
    render: row => (row.isEnabled ? 'Enabled' : 'Disabled')
  }
]

export const getFilters = () => [
  {
    name: 'isEnabled',
    value: '',
    filter: <Autocomplete variant="outlined" label="Status" options={statusOptions} />,
    type: 'autocomplete',
    label: 'Status'
  }
]
